export default __webpack_public_path__ + "static/media/no-answer.5974fce4.svg";